import commonState from '../commons/state'
import { Workout } from '../../../models/workout'

const state = () => ({
  ...commonState,
  currentActivity: Workout,
  updateActivity: Workout,
})

export default state